<button
  (click)="onClick($event)"
  [matTooltip]="labels.tooltip"
  class="copy-button"
>
  <mat-icon>file_copy</mat-icon>
</button>
